import { render, staticRenderFns } from "./EarningDetail.vue?vue&type=template&id=2fba69bb&scoped=true&"
import script from "./EarningDetail.vue?vue&type=script&lang=js&"
export * from "./EarningDetail.vue?vue&type=script&lang=js&"
import style0 from "./EarningDetail.vue?vue&type=style&index=0&id=2fba69bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba69bb",
  null
  
)

export default component.exports